// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___1lvb5","link":"link___1ltgW","logo":"logo___VjXfz","title":"title___3tX0o","seller":"seller___2uSm9","catalog":"catalog___1yW9V"};